import SelectSendTerminalParametersModal from './select-send-terminal-parameters-modal.vue'
export default SelectSendTerminalParametersModal
